import React, { useEffect, useState, useRef } from "react";
import FunFacts from "../../containers/FunFacts/FunFacts";
import { Sliders } from "../../containers/SliderContainers/Sliders";
import { startMeasure, endMeasure } from "../../utils/performanceMonitor";
import { preloadCriticalImages } from "../../utils/imageUtils";
import "../../assets/css/home-page.css";

const Home01 = () => {
    const [isotopeLoaded, setIsotopeLoaded] = useState(false);
    const criticalImagesLoaded = useRef(false);

    // Track component mount time
    useEffect(() => {
        startMeasure('Home01_render');
        
        // Preload critical images for the home page
        if (!criticalImagesLoaded.current) {
            const criticalImages = [
                '/images/EvD_logo.png'
                // Add other critical images here
            ];
            
            preloadCriticalImages(criticalImages);
            criticalImagesLoaded.current = true;
        }
        
        return () => {
            endMeasure('Home01_render');
        };
    }, []);

    useEffect(() => {
        // Track isotope initialization time
        startMeasure('isotope_init');
        // Only initialize Isotope if the grid element exists
        const gridElement = document.querySelector('.grid');
        if (!gridElement) return;
        
        // Dynamically import Isotope only when needed
        import('isotope-layout').then((IsotopeModule) => {
            const Isotope = IsotopeModule.default;
            const isotope = new Isotope(gridElement, {
                itemSelector: '.grid-item',
                percentPosition: true,
                layoutMode: 'packery',
                masonry: {
                    columnWidth: '.grid-sizer'
                },
                transformsEnabled: true,
                transitionDuration: "700ms",
                resize: true,
                fitWidth: true
            });
            
            endMeasure('isotope_init');
            setIsotopeLoaded(true);
            
            // Proper cleanup to prevent memory leaks
            return () => {
                if (isotope) {
                    isotope.destroy();
                }
            };
        });
    }, []); // Empty dependency array means this runs once on mount
    
    return (
        <div className="wrapper">
            {/* Removed Suspense wrappers to avoid loading indicators */}
            <Sliders />
            <FunFacts className="funfacts bg_1" />
        </div>
    );
};

export default Home01;
